import React from 'react'
import './Footer.css'
import hostName from '../../../method/hostname'

export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="t_footer">
      <div className="box">
        <p>
          @{year} {hostName} All Rights Reserved
        </p>
        <p>
          <a href="/policy.html">Privacy Policy</a> | <a href="/useragreement.html">Terms of Service</a> | <a href="/about.html">About Us</a>
        </p>
        <p>Contact us at : h5service@{hostName}</p>
      </div>
    </footer>
  )
}
